import React, { memo } from 'react'
import { Box, Button } from '@mui/material'
import ControlPointIcon from '@mui/icons-material/ControlPoint'
import PropTypes from 'prop-types'
import OnlyVisible from '@v4/components/common/OnlyVisible'
import { useEmptyMainSection } from './EmptyMainSection.hooks'

const EmptyMainSection = props => {
	const [{ classes, text, buttonLabel }, { handleAddSection }] = useEmptyMainSection(props)

	return (
		<Box className={classes.root}>
			<div className={classes.blockWrap}>
				<OnlyVisible />
				<p className={classes.text}>{text}</p>
				<Button
					className={classes.button}
					startIcon={<ControlPointIcon />}
					variant="outlined"
					onClick={handleAddSection}
				>
					{buttonLabel}
				</Button>
			</div>
		</Box>
	)
}

EmptyMainSection.propTypes = {
	pageType: PropTypes.string.isRequired,
}
export default memo(EmptyMainSection)
